import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Phone from 'react-phone-number-input';
import cn from 'classnames';
import styles from './PhoneInput.module.scss';

function PhoneInput(props) {
  const { name = '', disabled, value = '', placeholder = '', validate = [] } = props;

  const [error, setError] = useState({
    isError: false,
    message: '',
  });

  useEffect(() => {
    if (disabled) {
      const nodes = document.getElementsByName(name + '__country');
      if (nodes.length > 0) {
        nodes[0].setAttribute('disabled', 'true');
      }
    }
  }, [disabled, name]);

  const handleBlur = () => {
    checkErrors(value);
  };

  const handleChange = (inputValue) => {
    const input = {
      target: {
        name,
        value: inputValue,
      },
    };

    props.onChange(input);
    checkErrors(inputValue);
  };

  const checkErrors = (value) => {
    validate.some((validator) => {
      const result = validator(value);
      setError(result);

      // break (return true) if doesn't pass validation
      return result.isError;
    });
  };

  return (
    <div
      className={cn(
        styles.wrapper_input,
        error.isError ? styles.isError + ' ic-warning' : '',
        disabled ? styles.disabled : '',
        props.noMargin ? styles.noMargin : '',
      )}
    >
      <Phone
        name={name}
        country="US"
        placeholder={error.isError && value === '' ? error.message : placeholder}
        onChange={handleChange}
        value={value}
        onBlur={props.blur ? handleBlur : null}
      />
    </div>
  );
}

export default PhoneInput;

PhoneInput.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  name: PropTypes.string,
  validate: PropTypes.arrayOf(PropTypes.func),
  blur: PropTypes.bool,
  disabled: PropTypes.bool,
  noMargin: PropTypes.bool,
};
